import Rollbar from 'rollbar';

const rollbarConfig: Rollbar.Configuration = {
  accessToken: '70deb19b23b9461dbe750207986e697e',
  captureUncaught: !__DEVELOPMENT__,
  // enabled: !__DEVELOPMENT__,
  environment: __STAGING__ ? 'staging' : process.env.NODE_ENV,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        code_version: '1.0.0',
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
};

export default rollbarConfig;
